import { gql } from 'graphql-request'

export default gql`
  query getMedicalEquipmentNeedsRegister($provider: String) {
    applications {
      medicalEquipment {
        needsRegister(provider: $provider) {
          success
          needs_register
        }
      }
    }
  }
`
